package com.htmlagent.shared

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * The language the interface is in, and therefore the one the agent answers and writes in.
 *
 * It travels with every message because the model must not have to guess it: a two-word brief
 * ("una landing") does not say enough, and someone using the interface in English while writing
 * in Spanish has no right answer to infer.
 */
@Serializable
enum class UiLocale {
    @SerialName("es")
    SPANISH,

    @SerialName("en")
    ENGLISH,
    ;

    /** The value for the `lang` attribute and for the browser's formatting APIs. */
    val tag: String get() = if (this == SPANISH) "es" else "en"

    /** What the model is told to write in. */
    val englishName: String get() = if (this == SPANISH) "Spanish" else "English"

    companion object {
        /**
         * Reads a browser language tag. Anything that is not Spanish falls to English, which is
         * what someone arriving with another language expects to find.
         */
        fun ofTag(tag: String?): UiLocale =
            if (tag?.lowercase()?.startsWith("es") == true) SPANISH else ENGLISH
    }
}
